import { configureStore } from "@reduxjs/toolkit";

import isEnabled from "~utils/features";

import stories from "./features/stories-slice";
import translation from "./features/translation-slice";
import transporter from "./features/transporter-slice";

const IS_REDUX_DEV_TOOLS_ENABLED = isEnabled("enableReduxDevTools");

const store = (preloadedState = {}) =>
    configureStore({
        reducer: {
            stories,
            transporter,
            translation,
        },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
        devTools: IS_REDUX_DEV_TOOLS_ENABLED,
        preloadedState,
    });

export default store;
export type AppStore = ReturnType<typeof store>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
